import {
  GET_VOLUNTEERS,
  GET_VOLUNTEERS_SUCCEEDED,
  GET_VOLUNTEERS_FAILED,
  SIGN_UP_VOLUNTEER,
  SIGN_UP_VOLUNTEER_SUCCEEDED,
  SIGN_UP_VOLUNTEER_FAILED,
  SEARCH_VOLUNTEERS_REQUESTED,
  SEARCH_VOLUNTEERS_SUCCEEDED,
  SEARCH_VOLUNTEERS_FAILED,
  SEARCH_VOLUNTEERS_CLEARED,
} from '../actions'
import getErrorMessage from '../../utils/getErrorMessage'

const emptySearch = { query: '', results: [], loading: false, error: null }

export default function (state, action) {
  switch (action.type) {
    case GET_VOLUNTEERS:
      return {
        ...state,
        getVolunteers: { running: true, error: null },
      }

    case GET_VOLUNTEERS_SUCCEEDED:
      return {
        ...state,
        volunteers: action.payload.volunteers,
        getVolunteers: { running: false, error: null },
      }

    case GET_VOLUNTEERS_FAILED:
      return {
        ...state,
        getVolunteers: {
          running: false,
          error: getErrorMessage(action.payload.error),
        },
      }

    case SIGN_UP_VOLUNTEER:
      return {
        ...state,
        signUpVolunteer: { running: true, error: null },
      }

    case SIGN_UP_VOLUNTEER_SUCCEEDED:
      return {
        ...state,
        volunteers: [action.payload.newVolunteer, ...state.volunteers],
        signUpVolunteer: { running: false, error: null },
      }

    case SIGN_UP_VOLUNTEER_FAILED:
      return {
        ...state,
        signUpVolunteer: {
          running: false,
          error: getErrorMessage(action.payload.error),
        },
      }

    case SEARCH_VOLUNTEERS_REQUESTED:
      return {
        ...state,
        search: {
          query: action.payload.query,
          results: state.search ? state.search.results : [],
          loading: true,
          error: null,
        },
      }

    case SEARCH_VOLUNTEERS_SUCCEEDED:
      // Drop the result if it's not for the latest query (saga uses takeLatest,
      // so this is mostly belt-and-braces).
      if (state.search && state.search.query !== action.payload.query) {
        return state
      }
      return {
        ...state,
        search: {
          query: action.payload.query,
          results: action.payload.results,
          loading: false,
          error: null,
        },
      }

    case SEARCH_VOLUNTEERS_FAILED:
      if (state.search && state.search.query !== action.payload.query) {
        return state
      }
      return {
        ...state,
        search: {
          ...(state.search || emptySearch),
          query: action.payload.query,
          loading: false,
          error: getErrorMessage(action.payload.error),
        },
      }

    case SEARCH_VOLUNTEERS_CLEARED:
      return {
        ...state,
        search: emptySearch,
      }

    default:
      return state
  }
}
